import React, { useState, useEffect, useCallback } from "react";
import * as api from "../services/projectApi";
import { useAuth } from "../../auth/AuthContext";
import StrategyViewer from "./StrategyViewer";

export default function VersionHistory({ projectId, currentVersion, onRestored }) {
  const { has } = useAuth();
  const [versions, setVersions] = useState([]);
  const [viewing, setViewing] = useState(null); // parsed version being viewed
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    api.getStrategyVersions(projectId).then(setVersions).catch(() => {});
  }, [projectId]);

  useEffect(() => { load(); }, [load, currentVersion]);

  const view = async (versionId) => {
    setBusy(true);
    try {
      setViewing(await api.getStrategyVersion(versionId));
    } finally {
      setBusy(false);
    }
  };

  const restore = async (versionId) => {
    if (!window.confirm("Restore this version as the latest strategy?")) return;
    await api.restoreStrategyVersion(versionId);
    setViewing(null);
    onRestored?.();
  };

  if (versions.length === 0) return null;

  return (
    <div className="version-history">
      <h4>Version history</h4>
      <ul className="version-list">
        {versions.map((v) => (
          <li key={v.id}>
            <span className="version-num">V{v.version}</span>
            {v.approved && <span className="proj-badge-inline">approved</span>}
            <span className="proj-sub">{new Date(v.createdAt).toLocaleString()}</span>
            <span className="version-actions">
              <button className="proj-link" disabled={busy} onClick={() => view(v.id)}>view</button>
              {has("strategy.generate") && (
                <button className="proj-link" onClick={() => restore(v.id)}>restore</button>
              )}
            </span>
          </li>
        ))}
      </ul>

      {viewing && (
        <div className="proj-modal-backdrop" onClick={() => setViewing(null)}>
          <div className="proj-modal version-modal" onClick={(e) => e.stopPropagation()}>
            <div className="proj-progress-head">
              <h2>Strategy · V{viewing.version}</h2>
              <button className="proj-link" onClick={() => setViewing(null)}>close</button>
            </div>
            <StrategyViewer strategy={viewing.strategy} />
          </div>
        </div>
      )}
    </div>
  );
}
